<template>
    <div class="partner-listing-wrapper">
        <div>
            <!-- HERO SECTION -->
            <div class="partner-hero-content container">
                <div v-if="loading">
                    <img class="" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/partners/placeholder_header.svg" alt="">
                    <!-- <img class="" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/partners/placeholder_header.svg" alt="">
                    <img class="" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/partners/placeholder_header.svg" alt=""> -->
                </div>
                <div v-if="!loading && partnerDetails" class="bg-gradient-primary mt-n4 pt-4 expert-hero-bg partners-listing-wrapper rounded-bottom-10 p-3 px-4 mx-n3 mx-md-0">
                    <div class="align-items-lg-center d-flex flex-column flex-lg-row justify-content-center pt-4 mt-3 pb-lg-3">
                        <!-- Logo Section -->
                        <div class="mb-4 mb-lg-0 mr-0 mr-lg-4 d-flex partner-logo-section">
                            <img v-if="partnerDetails.logo && partnerDetails.logo.x" :src="partnerDetails.logo.x" alt="Partner Logo" class="mr-lg-4 mt-lg-3 rounded-corners-10 shadow-sm">
                            <img v-else src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/partners/Placeholder PARTNER LOGO image on png.svg" alt="" class="shadow-sm align-self-center">
                            <div class="align-self-center d-block d-lg-none">
                                <div class="ml-3">
                                    <h4 v-if="partnerDetails.name" class="font-weight-bolder text-white">{{ partnerDetails.name }}</h4>
                                    <span v-if="partnerDetails.type.displayNameInPartner" class="badge bg-light text-dark align-self-center">{{ partnerDetails.type.displayNameInPartner }}</span>
                                </div>
                            </div>
                        </div>
                        <!-- Text Section -->
                        <div class="text-white">
                            <!-- Title and Badge -->
                            <div class="d-lg-block d-none">
                                <div class="align-items-center mb-3">
                                    <h1 v-if="partnerDetails.name" class="h2 font-weight-bolder mr-4">{{ partnerDetails.name }}</h1>
                                    <span v-if="partnerDetails.type.displayNameInPartner" class="badge bg-light text-dark align-self-center">{{ partnerDetails.type.displayNameInPartner }}</span>
                                </div>
                            </div>
                            <!-- Information List -->
                            <div class="mb-4 d-flex flex-column">
                                <div v-if="partnerDetails.yearFounded" class="d-flex">
                                    <span class="mr-2">{{ $t('Partners.yearFounded')  }}</span>
                                    <span>{{ partnerDetails.yearFounded }}</span>
                                </div>
                                <div v-if="partnerDetails.employeeCount" class="d-flex">
                                    <span class="mr-2">{{ $t('Partners.employeeCount')  }}</span>
                                    <span>{{ partnerDetails.employeeCount }}</span>
                                </div>
                                <div v-if="partnerDetails.headquartersCity" class="d-flex">
                                    <span class="mr-2">{{ $t('Partners.location')  }}</span>
                                    <span>{{ partnerDetails.headquartersCity }}</span>
                                </div>
                            </div>

                            <!-- Buttons -->
                            <div class="d-flex flex-md-row flex-column">
                                <!-- <a 
                                    v-if="partnerDetails.email"
                                    class="btn btn-light d-flex font-weight-bold justify-content-center mb-2 mb-md-0 mr-md-2 px-5 rounded-corners-10 text-dark"
                                    @click="openMailto(partnerDetails.email)"
                                >
                                    <span class="mr-1">{{ $t('Partners.emailUs')  }}</span>
                                    <img class="align-self-center" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/partners/mail_20dp_000000_FILL0_wght200_GRAD0_opsz20.svg" alt="">
                                </a> -->
                                <button 
                                    v-if="partnerDetails.deepLink"
                                    class="btn btn-outline-light px-5 rounded-corners-10 font-weight-bold d-flex justify-content-center share-button"
                                    @mouseover="isHovered = true" 
                                    @mouseleave="isHovered = false"
                                    @click="copyToClipboard(partnerDetails.deepLink)"
                                >
                                    <span v-if="!isCopied" class="mr-1">{{ $t('Partners.share')  }}</span>
                                    <!-- check icon -->
                                    <img 
                                        v-if="isCopied" 
                                        class="align-self-center" 
                                        alt=""
                                        :src="isHovered 
                                        ? '/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/partners/check_16dp_000000_FILL0_wght400_GRAD0_opsz20.svg' 
                                        : '/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/partners/check_16dp_FFFFFF_FILL0_wght400_GRAD0_opsz20.svg'"  
                                    >
                                    <span v-if="isCopied" class="ml-1">{{ $t('Partners.copiedToClipboard') }}</span>
                                    <img 
                                        :src="isHovered 
                                        ? '/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/partners/ios_share_20dp_000000_FILL0_wght500_GRAD0_opsz20.svg' 
                                        : '/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/partners/ios_share_20dp_FFFFFF_FILL0_wght500_GRAD0_opsz20.svg'"  
                                        alt=""
                                        v-if="!isCopied"
                                    >
                                </button>
                              
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- TAB SECTION -->
            <div class="mt-3">
                <div v-if="loading">
                    <img src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/partners/placeholder_tabs.svg" alt="" class="w-100">
                </div>
                <div v-if="!loading && partnerDetails">
                    <ul class="platform-partner-tabs nav nav-tabs custom-tabs tab-bottom-primary justify-content-center">
                        <li v-if="(teamMembers && teamMembers.length) || (partnerDetails.expertIds && partnerDetails.expertIds.length) || (pocs && pocs.length)" class="nav-item">
                            <button class="nav-link px-2 px-md-5 border-0 bg-transparent" :class="{ active: selectedTab === 'info' }" @click="selectedTab = 'info';saveSelectedTabInfoIn()">
                                {{ $t('Partners.info') }}
                            </button>
                        </li>
                        <li v-if="teamMembers && teamMembers.length" class="nav-item">
                            <button class="nav-link px-2 px-md-5 border-0 bg-transparent" :class="{ active: selectedTab === 'team' }" @click="selectedTab = 'team';saveSelectedTabInfoIn()" >
                                {{ $t('Partners.team') }}
                            </button>
                        </li>
                        <li v-if="partnerDetails.expertIds && partnerDetails.expertIds.length" class="nav-item">
                            <button class="nav-link px-2 px-md-5 border-0 bg-transparent" :class="{ active: selectedTab === 'experts' }" @click="selectedTab = 'experts';saveSelectedTabInfoIn()" >
                                {{ $t('Partners.experts') }}
                            </button>
                        </li>
                        <li v-if="partnerDetails.contactMemberIds && partnerDetails.contactMemberIds.length" class="nav-item">
                            <button class="nav-link px-2 px-md-5 border-0 bg-transparent" :class="{ active: selectedTab === 'inhalte' }" @click="selectedTab = 'inhalte';saveSelectedTabInfoIn()">
                                {{ $t('Partners.content') }}
                            </button>
                        </li>
                    </ul>

                    <!-- Tab Content -->
                    <div class="">
                        <div class="tab-content">
                            <div class="article-width">
                                <KeepAlive>
                                    <InfoTab v-bind:settingsPerm="settingsPerm" v-if="selectedTab === 'info'" :partnerDetails="partnerDetails"/>
                                </KeepAlive>
                            </div>
                            <div class="article-width">
                                <KeepAlive>
                                    <TeamTab v-bind:settingsPerm="settingsPerm" v-if="selectedTab === 'team'" :teamMembers="teamMembers" :loadingStuffMembers="loadingStuffMembers" :deepLink="partnerDetails.deepLink" />
                                </KeepAlive>
                            </div>
                           <div class="article-width">
                                <KeepAlive>
                                    <ExpertsTab v-bind:settingsPerm="settingsPerm" v-if="selectedTab === 'experts'" :experten="experten" :expertIds="expertIds" :loadingExperts="loadingExperts"/>
                                </KeepAlive>
                           </div>
                            <div class="container">
                                <KeepAlive>
                                    <InhalteTab v-bind:settingsPerm="settingsPerm" v-if="selectedTab === 'inhalte'" :partnerDetails="partnerDetails"/>
                                </KeepAlive>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
    
<script>
    import { ApolloClient, InMemoryCache } from '@apollo/client/core';
    import { provideApolloClient, useQuery } from "@vue/apollo-composable";
    import CONCORD_QUERIES from "../../../services/concord_queries.js";
    import { watch } from 'vue';
    import InfoTab from './InfoTab.vue';
    import TeamTab from './TeamTab.vue';
    import ExpertsTab from './ExpertsTab.vue';
    import InhalteTab from './InhalteTab.vue';

    export default {
        name: 'partnerDetailsPage',
        components: {
        InfoTab,
        TeamTab,
        ExpertsTab,
        InhalteTab
    },
        props: {
            settingsPerm: Object
        },
        data() {
            return {
                loading: true,
                loadingStuffMembers: true,
                loadingExperts: true,
                loadingPocs: true,
                partnerTypes: false,
                isDevMioActive: this.settingsPerm.isDevMioActive,
                isDevmioNlActive: this.settingsPerm.isDevmioNlActive,
                selectedTab: "info",
                partnerDetails: false,
                isHovered : false,
                isCopied: false,
                experten: [],
                expertIds: false,
                teamMembers: [],
                contactMemberIds: false,
            };              
        },
        created() {
            // console.log('settingsPerm', this.settingsPerm);
            const customHeaders = {
                platform: "web", // Add your custom header(s) here
                App: this.isDevmioNlActive
                ? "devmionl"
                : this.isDevMioActive
                ? "devmio"
                : "entwickler"
            };
            const cache = new InMemoryCache();
            const apolloClient = new ApolloClient({
                cache,
                uri: this.settingsPerm.concordBackendURL,
                headers: customHeaders,
            })
            provideApolloClient(apolloClient)

            let variablesForQuery = {
                slug: this.settingsPerm.partnerSlug
            };
            const {
                result
            } = useQuery(CONCORD_QUERIES.GET_PARTNER_DETAILS, variablesForQuery);
            watch(result, value => {
                if (value && value.platformPartner && value.platformPartner.PlatformPartner) {
                    this.loading = false;
                    this.partnerDetails = value.platformPartner.PlatformPartner;
                } else {
                    this.loading = false;
                }
            })
            this.getExpertsByExpertIds();
            this.getPartnerStuffMembers();
        },
        methods: {
            selectTab(tab) {
                this.selectedTab = tab;
            },
            copyToClipboard(link) {
                const textarea = document.createElement('textarea');
                textarea.value = link;
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea); 
                this.isCopied = true;

                setTimeout(() => {
                    this.isCopied = false;
                }, 3000);
            },
            getExperts(expertIds) {
                //get partner experts
                let variablesForQuery = {
                    ids: expertIds,
                    page: 1,
                    pagesize: 130
                };
                const {
                    result
                } = useQuery(CONCORD_QUERIES.GET_PARTNER_EXPERTS, variablesForQuery);
                watch(result, value => {
                    // add proper checks
                    if (value && value.authors && value.authors.Authors && value.authors.Authors.length) {
                        this.experten = value.authors.Authors;
                        this.loadingExperts = false;
                    } else {
                        this.loadingExperts = false;
                    }
                })
            },
            getExpertsByExpertIds(){
                let variablesForQuery = {
                slug: this.settingsPerm.partnerSlug
                };
                const {
                    result
                } = useQuery(CONCORD_QUERIES.GET_EXPERT_IDS, variablesForQuery);
                watch(result, value => { 
                    if (value && value.platformPartner && value.platformPartner.PlatformPartner && value.platformPartner.PlatformPartner.expertIds && value.platformPartner.PlatformPartner.expertIds.length) {
                        this.expertIds = value.platformPartner.PlatformPartner.expertIds;
                        this.getExperts(this.expertIds);
                        this.loadingExperts = false;
                        
                    } else {
                        this.loadingExperts = false;
                    }
                })
            },
            getTeamMember(_id) {
                //get partner experts
                let variablesForQuery = {
                    id: _id,
                };
                const {
                    result
                } = useQuery(CONCORD_QUERIES.GET_PARTNER_STAFF, variablesForQuery);
                watch(result, value => {
                    // add proper checks
                    if (value && value.platformPartnerStaffMembers && value.platformPartnerStaffMembers.PlatformPartnerStaffMembers && value.platformPartnerStaffMembers.PlatformPartnerStaffMembers.length) {
                        // console.log('teammmmmmmmmmm',  value);
                        this.teamMembers = value.platformPartnerStaffMembers.PlatformPartnerStaffMembers;
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                })
            },
            getPartnerStuffMembers(){
                // get the expert ids
                let variablesForQuery = {
                slug: this.settingsPerm.partnerSlug
                };
                const {
                    result
                } = useQuery(CONCORD_QUERIES.GET_STAFF_IDS, variablesForQuery);
                watch(result, value => { 
                    if (value && value.platformPartner && value.platformPartner.PlatformPartner && value.platformPartner.PlatformPartner._id && value.platformPartner.PlatformPartner._id.length) {
                        // console.log('teamMemberIds',  this._id);
                        this.getTeamMember(value.platformPartner.PlatformPartner._id);
                        this.loadingStuffMembers = false;
                        
                    } else {
                        this.loadingStuffMembers = false;
                    }
                })
            },
            
            saveSelectedTabInfoIn() {
                // save selected tab along with slug in local storage for 1 hour
                const expiryTime = new Date().getTime() + 3600 * 1000; // 1 hour from now
                let selectedTab = this.selectedTab;
                let slug = this.settingsPerm.partnerSlug;
                const tabInfo = {
                selectedTab,
                slug,
                expiresAt: expiryTime
                };

                localStorage.setItem('selectedTabInfoVue', JSON.stringify(tabInfo));
            },

            getSelectedTabInfo() {
                const tabData = localStorage.getItem('selectedTabInfoVue');
                const parsed = JSON.parse(tabData);
                const currentTime = new Date().getTime();
                if (parsed.expiresAt && parsed.expiresAt > currentTime) { 
                    if (parsed.selectedTab && parsed.selectedTab != "info" && parsed.slug && parsed.slug == this.settingsPerm.partnerSlug) {
                        this.selectedTab = parsed.selectedTab;
                    }
                }
            }
    
        },
    }

</script>

    <style scoped>
        button:focus {
            outline: none;
            box-shadow: none;
        }
       .partner-logo-section img{
            max-height: 235px;
        }
        .article-width{
            max-width: 1056px;
            margin: 0 auto;
        }
        .platform-partner-tabs{
            gap: 35px;
        }
        /* 767px */
        @media (max-width: 48em) {
            .partner-logo-section img{
                max-height: 100px;
            }
        }
    </style>
    